'use strict';

import {
  analyticsCtaDataObject,
  handleFileDownloadEvent,
} from '../helpers/adobe-analytics';

// Delegated tracker for plain `<a data-analytics-download href="...">` anchors
// rendered by ERB partials that can't easily use `<download-button>` or
// `<cta-text>`. Data attributes on the anchor supply the analytics payload.
//
// Required: data-file-name, data-placement.
// Optional: data-file-format (defaults to the href's extension),
//           data-link-type (defaults derived by analyticsCtaDataObject),
//           data-link-url (defaults to the anchor's href).
const analyticsDownloadTracker = (function() {
  function onClick(event) {
    const anchor = event.target.closest('a[data-analytics-download]');
    if (!anchor) return;

    const href = anchor.getAttribute('href') || '';
    const fileName = anchor.dataset.fileName || '';
    const payload = {
      file_format: anchor.dataset.fileFormat || '',
      isDownload: true,
      file_name: fileName,
      // `text` lets analyticsDownloadType() pick up REVIT/CAD hints
      // from the title when link_type isn't set explicitly.
      text: fileName,
      link_url: anchor.dataset.linkUrl || href,
      link_type: anchor.dataset.linkType || '',
      placement: anchor.dataset.placement || '',
    };

    handleFileDownloadEvent(analyticsCtaDataObject(payload));
  }

  document.addEventListener('click', onClick);
})();

export default analyticsDownloadTracker;
